import { render, staticRenderFns } from "./JWL_ProgrammeFinish.vue?vue&type=template&id=3746c7ac&lang=pug&"
import script from "./JWL_ProgrammeFinish.vue?vue&type=script&lang=ts&"
export * from "./JWL_ProgrammeFinish.vue?vue&type=script&lang=ts&"
import style0 from "./JWL_ProgrammeFinish.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports